import { render, staticRenderFns } from "./Compositing.vue?vue&type=template&id=47e22683&scoped=true"
import script from "./Compositing.vue?vue&type=script&lang=js"
export * from "./Compositing.vue?vue&type=script&lang=js"
import style0 from "./Compositing.vue?vue&type=style&index=0&id=47e22683&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e22683",
  null
  
)

export default component.exports